import { useEffect, useState } from "react";
import "./Kepler22b.css";
import CubesAnim from "../Animation/CubesAnim";
import img_1 from "../../assets/Images/keplerImg_5.jpg";
import img_2 from "../../assets/Images/keplerImg_2.jpg";
import img_3 from "../../assets/Images/keplerImg_3.jpg";
import img_4 from "../../assets/Images/keplerImg_4.jpg";
import img_5 from "../../assets/Images/keplerImg_1.jpg";
import img_6 from "../../assets/Images/keplerImg_6.jpg";
import img_7 from "../../assets/Images/keplerImg_7.jpg";

const Kepler22b = () => {
  const [runGallery, setRunGalery] = useState(0);
  const [step, setStep] = useState(0);
  const second = 5000;

  useEffect(() => {
    setInterval(() => {
      if (true) {
        setStep((prevState)=>{
          if (prevState === 2) {
            return prevState;
          }
          return prevState + 1;
        });
      }
    }, second);
  }, []);

  const textArr = [
    `Your journey with us will begin on January 1st, 2030 at 12 am, from the launch station in Belgrade(Zvezdara). Till then, all supplies and machines will already be in a selected place on Kepler 22b surface. The first stop will be on the edge of our Solar System when we will be able to see for the last time Sun in full glory.`,
    `Then, you will be hibernating for about 5 years. You will be in a deep sleep, as soon as you wake up you will be able to see the fabulous planet, which will be your place of living for 1 year.It would be something like living in a hotel with great views. Those views will only your and few people eyes see, and no one else from planet Earth. Besides that, you will be able to hike, climb mountins, swim, explore, and much more, all that on a totally new planet.`,
    `Then, trip back, ease from the start, and when we reach the edge of the Kepler system, again hibernating for 5 years, when you wake up earth will be on your sight.`,
  ];

  let jsxTxt = textArr[step];

  let galleryFun = (x) => {
    if (runGallery >= -600 && runGallery <= 0) {
      setRunGalery((runGallery) => runGallery + x);
    } else {
      setRunGalery(0);
    }
  };

  return (
    <div className="kepler">
      <div className="kepler_overDiv">
        <i
          className="far fa-caret-square-left"
          onClick={() => galleryFun(100)}
        ></i>
        <h2 className="kepler_txt">{jsxTxt}</h2>
        <i
          className="far fa-caret-square-right"
          onClick={() => galleryFun(-100)}
        ></i>
      </div>
      <div
        className="container"
        style={
          runGallery >= -600 && runGallery < 0
            ? { marginLeft: runGallery + "vw" }
            : { marginLeft: 0 + "vw" }
        }
      >
        <div className="imgs_div">
          <img src={img_1} alt="Kepler Planet" />
        </div>
        <div className="imgs_div">
          <img src={img_2} alt="Kepler Planet" />
        </div>
        <div className="imgs_div">
          <img src={img_3} alt="Kepler Planet" />
        </div>
        <div className="imgs_div">
          <img src={img_4} alt="Kepler Planet" />
        </div>
        <div className="imgs_div">
          <img src={img_5} alt="Kepler Planet" />
        </div>
        <div className="imgs_div">
          <img src={img_6} alt="Kepler Planet" />
        </div>
        <div className="imgs_div">
          <img src={img_7} alt="Kepler Planet" />
        </div>
      </div>
      <CubesAnim />
    </div>
  );
};
export default Kepler22b;
